import React from "react";
import "./StatsSection.css";

import amazonLogo from '../../../Images/image1/Accenture.png';
import googleLogo from "../../../Images/image1/Amazon-Logo.png";
import microsoftLogo from "../../../Images/image1/IBM.png";
import goldmanLogo from "../../../Images/image1/Infosys-Logo.jpg";
import paypalLogo from "../../../Images/image1/Microsoft-Logo.png";
import samsungLogo from "../../../Images/image1/TCS.png";
import eyLogo from "../../../Images/image1/Dell_Logo.png";
import hitachiLogo from "../../../Images/image1/EY.png";
import jpmorganLogo from "../../../Images/image1/google.png";
import ibmLogo from "../../../Images/image1/hitachi_logo.png";
import jpmorganLogo1 from '../../../Images/image1/jp.jpg'
import samsung from '../../../Images/image1/Samsung.png'
import wipro from '../../../Images/image1/wipro.jpg'
import hex from '../../../Images/image1/hex.png'
import paypal from '../../../Images/image1/paypal.svg'
import techm from '../../../Images/image1/techm.png'
import cap from'../../../Images/image1/Capgemini-Logopng.png';
import Cognizant from '../../../Images/image1/cognizant.png';
import Hcl from '../../../Images/image1/HCL-logo.png';
import LT from '../../../Images/image1/L&T.png';


const StatsSection = () => {
  return (
    <div className="statsSection">
      <h2 className="statsTitle">
        Empowering Aspiring Developers to Build Their Future in Tech!
      </h2>

      <div className="statsHighlights">
        <div className="statItem">
          <h3>6 months</h3>
          <p>on average</p>
        </div>
        <div className="statItem">
          <h3>7,000,000+</h3>
          <p>students trained</p>
        </div>
        <div className="statItem">
          <h3>1 Billion+</h3>
          <p>views and counting</p>
        </div>
      </div>

      <div className="companySection">
        <h3>Helped students achieve their dream job at</h3>
        <div className="companyGrid">
          {[amazonLogo, googleLogo, microsoftLogo, goldmanLogo, paypalLogo, samsungLogo,Hcl,Cognizant,cap,LT,
            eyLogo, hitachiLogo, jpmorganLogo, ibmLogo,jpmorganLogo1,hex,samsung,techm,paypal,wipro].map((logo, index) => (
            <div className="companyCard" key={index}>
              <img src={logo} alt={`company-${index}`} />
            </div>
          ))}
        </div>
        <p className="moreCompanies">+ many more companies</p>
      </div>
    </div>
  );
};

export default StatsSection;
